<h1 matDialogTitle>Credit Invoiced Lines - {{data?.invoiceNumber}}</h1>

<mat-dialog-content>
  <div style="width: 100%">


    <mat-form-field style="width: 150px; margin-right: 16px">
      <mat-select [(ngModel)]="storeId" placeholder="Store" (selectionChange)="storeChanged($event)">
        <mat-option *ngFor="let store of stores" [value]="store.storeId">{{store.storeName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 150px; margin-right: 16px">
      <mat-select [(ngModel)]="warehouseCode" placeholder="Warehouse">
        <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.warehouseCode">{{warehouse.warehouseName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 300px; margin-right: 16px">
      <mat-label>Approved By Manager Email</mat-label>
      <input matInput type="email" [(ngModel)]="approvedByEmail" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field style="width: 300px;">
      <mat-label>Approved By Manager Password</mat-label>
      <input matInput type="password" [(ngModel)]="approvedByPwd" autocomplete="new-password">
    </mat-form-field>

    <kendo-grid *ngIf="lines" [kendoGridBinding]="lines" [scrollable]="true" [resizable]="true" [reorderable]="true"
      [sortable]="true">


      <kendo-grid-column [locked]="true" [width]="140" field="displayCode" title="Code">
      </kendo-grid-column>

      <kendo-grid-column [locked]="true" [width]="420" title="Description">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="ellipse">{{dataItem.lineDescription2 ? dataItem.lineDescription + ' - ' +
            dataItem.lineDescription2 :dataItem.lineDescription}}</span>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column [width]="100" field="warehouseCode" title="Warehouse"> </kendo-grid-column> -->

      <!-- <kendo-grid-column [width]="200" field="deliveryMethod" title="Del. Method">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="ellipse">{{dataItem.deliveryMethod}}</span>
        </ng-template>
      </kendo-grid-column> -->

      <kendo-grid-column [width]="120" field="allowedToReturnQty" class="td-number" title="Return Qty">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <mat-select [(ngModel)]="dataItem.returnQty" placeholder="">
            <mat-option *ngFor="let n of arrayOfNumbers(dataItem.allowedToReturnQty)" [value]="n">{{n}}</mat-option>
          </mat-select>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="250" field="returnReasonCode" title="Return Reason">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <mat-select *ngIf="dataItem.returnQty > 0" [(ngModel)]="dataItem.returnReasonCode" placeholder="">
            <mat-option *ngFor="let reason of reasons" [value]="reason.reasonCode">{{reason.description}}</mat-option>
          </mat-select>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineTotalAmount"
        title="Line Amt.">
      </kendo-grid-column> -->


    </kendo-grid>
  </div>
  <!-- <pre>{{selectedLines | json}}</pre>
  <pre>{{selectedLines.join(',')}}</pre> -->
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!valid" (click)="createCreditNote()">Create Credit Note</button>
</mat-dialog-actions>